import React from 'react'
import PropTypes from 'prop-types'
import UsersTable from './users-table'
import * as request from 'services/request'

const UsersComponent = ({ users, onSearch }) => (
  <div>
    <div className='row'>
      <div className='col-md-3 form-group'>
        <div className='input-group'>
          <input
            type='text'
            className='form-control'
            placeholder='Search'
            onChange={onSearch}
          />
          <span className='input-group-btn'>
            <button className='btn red'>
              <i className='fa fa-search' />
            </button>
          </span>
        </div>
      </div>
    </div>
    <UsersTable users={users} />
  </div>
)

UsersComponent.displayName = 'UsersComponent'

UsersComponent.propTypes = {
  users: PropTypes.array.isRequired,
  onSearch: PropTypes.func
}

class UsersContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      users: [],
      search: ''
    }
  }

  componentDidMount () {
    this.getUsers()
  }

  async getUsers () {
    const response = await request.authorized('/users')
    const users = await response.json()
    this.setState({ users })
  }

  getFilteredUsers () {
    const { users, search } = this.state
    const filteredUsers = search
      ? users.filter(u =>
          u.screenName.toLowerCase().includes(search.toLowerCase())
        )
      : users

    return filteredUsers
  }

  handleSearch (text) {
    this.setState({ search: text })
  }

  render () {
    return (
      <UsersComponent
        users={this.getFilteredUsers()}
        onSearch={({ target }) => this.handleSearch(target.value)}
      />
    )
  }
}

const MissingTokensIcon = () => <i
  className='fa fa-exclamation-triangle md-24 sm-24 xs-24 select-warning'
  title='Missing authentication tokens'
/>

export { UsersContainer, UsersComponent, MissingTokensIcon }



// WEBPACK FOOTER //
// ./src/pages/admin/users/users.js